export const steps = [
  'Select Persons to Delist',
  'Confirm Policies',
  'Sure to Delist?',
]

export const ADD_OR_DEL = {
  ADD_EMPLOYEE: 'ADD_EMPLOYEE',
  DELETE: 'DELETE',
  UPDATE: 'UPDATE',
}

export const IS_ADD = 'isAdd'

export const ENDORSEMENT_TYPE = {
  ADD: 'Add',
  UPDATE: 'Update',
}
